export const FaqsData = [
    {
        'area_heading': "General question",
        'data': [
            {
                'heading': "What makes House of Polani different from other travel agencies?",
                'para': `Our 50-year legacy, comprehensive service range, and dedicated team of 150+ professionals set us apart. We offer end-to-end travel solutions with offices in multiple countries.`

            },
            {
                'heading': "Do you offer customized travel packages?",
                'para': `Yes, we specialize in creating tailored travel experiences for both individual and corporate clients, considering specific preferences and requirements.`

            },
            {
                'heading': "How can I book your services?",
                'para': `You can book through our website, visit our offices in Karachi, Islamabad, or London, or contact our 24/7 customer service team.`

            },
            {
                'heading': "What types of travel insurance do you offer?",
                'para': `We provide both standard and customized insurance packages covering medical emergencies, trip cancellations, lost baggage, and other travel-related risks.`

            },
            {
                'heading': "Do you assist with visa applications?",
                'para': `Yes, we offer comprehensive visa facilitation services, including documentation preparation, submission, and follow-up with embassies.`

            },
            {
                'heading': "Can you handle large group bookings?",
                'para': ` Absolutely. We specialize in MICE tours and group travel arrangements with dedicated coordinators for seamless execution.`

            },
        ]
    },
  
    // {
    //     'area_heading': "Advance question",
    //     'data': [
    //         {
    //             'heading': "It is a long established fact that a reader will be distracted by the readable content?",
    //             'para': `There are many variations of passages of Lorem Ipsum available,
    //               but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.`

    //         },
    //         {
    //             'heading': "It is a long established fact that a reader will be distracted by the readable content?",
    //             'para': `There are many variations of passages of Lorem Ipsum available,
    //               but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.`

    //         },
    //         {
    //             'heading': "It is a long established fact that a reader will be distracted by the readable content?",
    //             'para': `There are many variations of passages of Lorem Ipsum available,
    //               but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.`

    //         },
    //         {
    //             'heading': "It is a long established fact that a reader will be distracted by the readable content?",
    //             'para': `There are many variations of passages of Lorem Ipsum available,
    //               but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.`

    //         }
    //     ]
    // },
]